import { getFocusableElements } from './utils';

const { store, ActionCreators, EventTypes, Backdrop } = __app__;
const { CssAnimation } = RS;

const CSS_CLASSES = {
	ELEMENT: 'search-popup',
	SHOW_ANIMATION_MODIFIER: 'search-popup--show',
	HIDE_ANIMATION_MODIFIER: 'search-popup--hide',
	SHOWN_MODIFIER: 'search-popup--shown',
	HIDDEN_MODIFIER: 'search-popup--hidden',
};

const Search = {
	init(element)
	{
		this.element = element;
		if (!this.element)
		{
			console.error('search element not found');
			return;
		}

		if (store.state.ui.offCanvas.shown)
			this.show();

		this.initToggleButtons();
		this.initKeyboard();
		this.initBackdrop();

		store.subscribe(EventTypes.UI_SEARCH_SHOWN, () => {
			this.show();
		});

		store.subscribe(EventTypes.UI_SEARCH_HIDDEN, () => {
			this.hide();
		});
	},

	initToggleButtons()
	{
		document.addEventListener('click', (event) => {
			if (event.target.dataset.toggle === 'search')
			{
				event.preventDefault();
				store.dispatch(ActionCreators.uiSearchToggle(event.target));
			}
		});
	},

	initKeyboard()
	{
		document.addEventListener('keydown', ({ key, shiftKey } ) => {
			if (!store.state.ui.search.shown)
				return;

			if (key === 'Tab')
			{
				const target = document.activeElement;

				if (
					document !== target &&
					this.element !== target &&
					!this.element.contains(target) &&
					!document.querySelector('.title-search-result').contains(this.element)
				)
				{
					const focusable = getFocusableElements(this.element);
					if (shiftKey)
						(focusable[focusable.length - 1] || this.element).focus();
					else
						(focusable[0] || this.element).focus();
				}
			}
		});

		document.addEventListener('keydown', ({ key }) => {
			if (!store.state.ui.search.shown)
				return;

			if (key === 'Escape' || key === 'Esc')
				store.dispatch(ActionCreators.uiSearchHide());
		});

		document.addEventListener('keydown', ({ key }) => {
			if (store.state.ui.search.shown)
				return;

			if (
				key === '/' &&
				!store.state.ui.modal.activeId &&
				(
					document.activeElement.tagName !== 'INPUT' &&
					document.activeElement.tagName !== 'TEXTAREA'
				)
			)
			{
				store.dispatch(ActionCreators.uiSearchShow());
			}
		});
	},

	initBackdrop()
	{
		this.backdrop = new Backdrop();
		this.backdrop.zIndex = 1100;

		this.backdrop.subscribe(Backdrop.Events.CLICK, event => {
			const result = document.querySelector('.title-search-result');
			if (result && result.style.display === 'block')
				return false;

			store.dispatch(ActionCreators.uiSearchHide());
		});
	},

	show()
	{
		if (this.element.classList.contains(CSS_CLASSES.SHOWN_MODIFIER))
			return;

		this.backdrop.show();

		store.dispatch(ActionCreators.uiFixScrollbar());

		this.element.classList.add(CSS_CLASSES.SHOWN_MODIFIER);
		this.element.classList.remove(CSS_CLASSES.HIDDEN_MODIFIER);
		CssAnimation.triggerAnimation(this.element, CSS_CLASSES.SHOW_ANIMATION_MODIFIER)
			.then(() => {
				const input = this.element.querySelector('input');
				if (input)
					input.focus();
			});
	},

	hide()
	{
		if (this.element.classList.contains(CSS_CLASSES.HIDDEN_MODIFIER))
			return;

		this.element.classList.remove(CSS_CLASSES.SHOWN_MODIFIER);
		this.element.classList.add(CSS_CLASSES.HIDDEN_MODIFIER);
		CssAnimation.triggerAnimation(this.element, CSS_CLASSES.HIDE_ANIMATION_MODIFIER)
			.then(() => {
				this.backdrop.hide();
				store.dispatch(ActionCreators.uiUnfixScrollbar());

				const result = document.querySelector('.title-search-result');
				if (result && result.style.display === 'block')
					result.style.display = 'none';
			});
	}
}

export default Search;